import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout'
import PfpStudioPage from './components/PfpStudioPage'
import BannerStudioPage from './components/BannerStudioPage'
import ModelsPage from './components/ModelsPage'
import './App.css'

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-ugandan-black font-arcade text-xs">
        <Routes>
          <Route path="/" element={<Layout />} />
          <Route path="/pfp-studio" element={<PfpStudioPage />} />
          <Route path="/banner-studio" element={<BannerStudioPage />} />
          <Route path="/models" element={<ModelsPage />} />
        </Routes>
      </div>
    </Router>
  )
}

export default App